import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  deleteBibliotecaFamilia,
  getBibliotecasFamilia,
  getBibliotecasFamiliaFiltered,
  getBibliotecasFamiliaById,
  insertBibliotecaFamilia,
  updateBibliotecaFamilia,
  updateBibliotecasFamiliaProducto,
  getBibliotecasFamiliaProductoById,
} from 'services/personalizacion'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_BIBFAMILIA() {
  try {
    const bibliotecasFamiliaData = yield call(getBibliotecasFamilia)
    if (bibliotecasFamiliaData.ok) {
      yield put({
        type: actions.BIBFAMILIA_LOAD_SUCCEEDED,
        payload: bibliotecasFamiliaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.BIBFAMILIA_LOAD_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar')
    yield all([
      put({
        type: actions.BIBFAMILIA_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBFAMILIA_BY_ID(action) {
  try {
    const bibliotecasFamiliaData = yield call(getBibliotecasFamiliaById, action.payload)
    if (bibliotecasFamiliaData.ok) {
      yield put({
        type: actions.BIBFAMILIA_LOAD_BY_ID_SUCCEEDED,
        payload: bibliotecasFamiliaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.BIBFAMILIA_LOAD_BY_ID_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar')
    yield all([
      put({
        type: actions.BIBFAMILIA_LOAD_BY_ID_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBFAMILIA_FILTERED(action) {
  try {
    const bibliotecasPredSvgData = yield call(getBibliotecasFamiliaFiltered, action.payload)
    if (bibliotecasPredSvgData.ok) {
      yield put({
        type: actions.BIBFAMILIA_FILTERED_LOAD_SUCCEEDED,
        payload: bibliotecasPredSvgData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Bibliotecas de Prediseño SVG')
      put({
        type: actions.BIBFAMILIA_FILTERED_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.BIBFAMILIA_FILTERED_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_BIBLIOTECA_FAMILIA(action) {
  try {
    const etiquetasFamiliaData = yield call(deleteBibliotecaFamilia, action.payload)
    if (etiquetasFamiliaData.ok) {
      yield put({
        type: actions.DELETE_BIBLIOTECA_FAMILIA_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.DELETE_BIBLIOTECA_FAMILIA_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar')
    yield all([
      put({
        type: actions.DELETE_BIBLIOTECA_FAMILIA_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBLIOTECA_FAMILIA(action) {
  try {
    const bibFamiliaData = yield call(updateBibliotecaFamilia, action.payload)
    if (bibFamiliaData.ok) {
      putMessage(messageType.SUCCESS, 'Cambios guardados')
      yield put({
        type: actions.BIBFAMILIA_UPDATE_SUCCEEDED,
        payload: bibFamiliaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.BIBFAMILIA_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar')
    yield all([
      put({
        type: actions.BIBFAMILIA_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_BIBLIOTECA_FAMILIA(action) {
  try {
    const bibFamiliaData = yield call(insertBibliotecaFamilia, action.payload)
    if (bibFamiliaData.ok) {
      putMessage(messageType.SUCCESS, 'Creada correctamente')
      yield put({
        type: actions.BIBFAMILIA_INSERT_SUCCEEDED,
        payload: { ...bibFamiliaData.data, fontFamily: action.payload?.fontFamily },
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar')
      put({
        type: actions.BIBFAMILIA_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar')
    yield all([
      put({
        type: actions.BIBFAMILIA_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_BIBPREGUNTA_PRODUCTO(action) {
  try {
    const bibliotecasFamiliaByProducto = yield call(
      updateBibliotecasFamiliaProducto,
      action.payload,
    )
    if (bibliotecasFamiliaByProducto.ok) {
      putMessage(
        messageType.SUCCESS,
        'Bibliotecas de Familia modificadas correctamente para este producto',
      )
      yield put({
        type: actions.BIBFAMILIA_PRODUCTO_UPDATE_SUCCEEDED,
        payload: bibliotecasFamiliaByProducto.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Bibliotecas de Familia para este producto')
      yield put({
        type: actions.BIBFAMILIA_PRODUCTO_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Biblioteca de Familia para este producto')
    yield all([
      put({
        type: actions.BIBFAMILIA_PRODUCTO_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_BIBFAMILIA_BY_PRODUCTO_ID(action) {
  try {
    const bibliotecasPreguntaData = yield call(getBibliotecasFamiliaProductoById, action.payload)
    if (bibliotecasPreguntaData.ok) {
      yield put({
        type: actions.BIBFAMILIA_PRODUCTO_BY_ID_SUCCEEDED,
        payload: bibliotecasPreguntaData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Familias')
      put({
        type: actions.BIBFAMILIA_PRODUCTO_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al cargar Biblioteca de Familias')
    yield all([
      put({
        type: actions.BIBFAMILIA_PRODUCTO_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.BIBFAMILIA_LOAD_REQUESTED, GET_BIBFAMILIA),
    takeEvery(actions.BIBFAMILIA_LOAD_BY_ID_REQUESTED, GET_BIBFAMILIA_BY_ID),
    takeEvery(actions.BIBFAMILIA_FILTERED_LOAD_REQUESTED, GET_BIBFAMILIA_FILTERED),
    takeEvery(actions.DELETE_BIBLIOTECA_FAMILIA_REQUESTED, DELETE_BIBLIOTECA_FAMILIA),
    takeEvery(actions.BIBFAMILIA_UPDATE_REQUESTED, UPDATE_BIBLIOTECA_FAMILIA),
    takeEvery(actions.BIBFAMILIA_INSERT_REQUESTED, INSERT_BIBLIOTECA_FAMILIA),
    takeEvery(actions.BIBFAMILIA_PRODUCTO_BY_ID_REQUESTED, GET_BIBFAMILIA_BY_PRODUCTO_ID),
    takeEvery(actions.BIBFAMILIA_PRODUCTO_UPDATE_REQUESTED, UPDATE_BIBPREGUNTA_PRODUCTO),
  ])
}
